// extracted by mini-css-extract-plugin
export default {"container":"qpV7mFPtAMuW1qpdNkfk","message":"jRAzBFDnf0G43hyqK2um","messageHidden":"GEgkGh4LyQHbwjA7wARa"};